import React from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import Address from "../searchresults/Address";
import getPersonName from "../common/Name";
import getBusinessName from "../common/Business";
import getPhone from "../common/Phone";
import getSsn from "../common/Ssn";

const getName = (node, props) =>
  getPersonName(
    _.get(node[0], "first[0]._", "") !== ""
      ? _.get(node[0], "first[0]._", "")
      : _.get(node[0], "firstName[0]._", ""),
    "",
    _.get(node[0], "last[0]._", "") !== ""
      ? _.get(node[0], "last[0]._", "")
      : _.get(node[0], "lastName[0]._", ""),
    props
  );

const getDate = (node, props) => {
  const { isSilverReport } = props;
  const nodeName = _.get(node[0], "$.display", "");
  const month = _.get(node[0], "month[0]._", "");
  const day = _.get(node[0], "day[0]._", "");
  const year = _.get(node[0], "year[0]._", "");
  if (isSilverReport && nodeName.toLowerCase() === "dob")
    return `${month !== "" ? `${month}/${year}` : year}`;
  return `${month !== "" ? `${month}/` : ""}${day !== "" ? `${day}/` : ""}${year !== "" ? `${year}` : ""
    }`;
};

export const getIndividualReportPart = (node, props) => {
  const rows = [];
  _.forEach(Object.keys(node), (key, index) => {
    if (key !== "$" && !key.endsWith("Id")) {
      const nodeName = _.get(node, `${key}[0].$.display`);
      const nodeValue = _.get(node, `${key}[0]._`);
      if (key.toLowerCase() === "name") {
        const name = getName(node[key], props);
        rows.push(
          <Table.Row key={`row_ind_${index}`}>
            <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
              }`}</Table.Cell>
            <Table.Cell width={10}>{name}</Table.Cell>
          </Table.Row>
        );
      } else if (key.toLowerCase() === "companyname") {
        rows.push(
          <Table.Row key={`row_ind_${index}`}>
            <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
              }`}</Table.Cell>
            <Table.Cell width={10}>
              {getBusinessName(nodeValue, props)}
            </Table.Cell>
          </Table.Row>
        );
      } else if (
        key.toLowerCase() === "ssn" &&
        nodeValue &&
        nodeValue.length === 11
      ) {
        const { isSilverReport } = props;
        if (!isSilverReport) {
          rows.push(
            <Table.Row key={`row_ind_${index}`}>
              <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
                }`}</Table.Cell>
              <Table.Cell width={10}>{getSsn(nodeValue, props)}</Table.Cell>
            </Table.Row>
          );
        }
      } else if (
        key.toLowerCase().indexOf("phone") !== -1 &&
        nodeValue &&
        nodeValue.length > 6
      ) {
        rows.push(
          <Table.Row key={`row_ind_${index}`}>
            <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
              }`}</Table.Cell>
            <Table.Cell width={10}>{getPhone(nodeValue, props)}</Table.Cell>
          </Table.Row>
        );
      } else if (
        (key.toLowerCase().indexOf("date") !== -1 ||
          key.toLowerCase() === "dob") &&
        nodeValue === undefined
      ) {
        const date = getDate(node[key], props);
        rows.push(
          <Table.Row key={`row_ind_${index}`}>
            <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
              }`}</Table.Cell>
            <Table.Cell width={10}>{date}</Table.Cell>
          </Table.Row>
        );
      } else if (key.toLowerCase().indexOf("address") !== -1) {
        rows.push(
          <Table.Row key={`row_ind_${index}`}>
            <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
              }`}</Table.Cell>
            <Table.Cell width={10}>
              {<Address addressNode={node[key][0]} ignoreLine1 />}
            </Table.Cell>
          </Table.Row>
        );
      } else {
        const value = _.get(node, `${key}[0]._`);
        if (value !== undefined) {
          rows.push(
            <Table.Row key={`row_ind_${index}`}>
              <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
                }`}</Table.Cell>
              <Table.Cell width={10}>{value}</Table.Cell>
            </Table.Row>
          );
        }
      }
    }
  });
  return rows;
};

export const getAllRows = (
  collection,
  rows,
  props,
  excludeNode,
  level = 0,
  displayOnlyTitle = undefined,
  ignoreEmptyNodes = false,
  ignorePhoto = true,
  includeId = false,
  position = 0
) => {
  _.forEach(Object.keys(collection), (key) => {
    if (includeId || !key.toLowerCase().endsWith("id")) {
      const nodeName = _.get(collection[key][0], `$.display`);
      const nodeValue = _.get(collection[key][0], `_`);
      const rand1 = Math.floor(Math.random() * 1000);
      const rand2 = Math.floor(Math.random() * 100);
      if (key === "$") {
        const headerName = _.get(collection[key], "display");
        if (headerName !== undefined) {
          const { isSilverReport } = props;
          if (
            headerName.toLowerCase().indexOf("token") !== -1 ||
            (isSilverReport && headerName.toLocaleLowerCase() === "ssnrecord")
          ) {
            // token or silver report ssn record header
          } else if (displayOnlyTitle !== undefined) {
            if (headerName === displayOnlyTitle) {
              rows.push(
                <Table.Row
                  key={`row_rec_header_${headerName}_${rand1}_${rand2}`}
                >
                  <Table.Cell
                    className="text-bold report-sub-title text-center"
                    colSpan={2}
                    width={16}
                  >{`${headerName !== undefined ? `${headerName}` : key
                    }`}</Table.Cell>
                </Table.Row>
              );
            }
          } else if (
            (headerName !== excludeNode && level === 0) ||
            position > level
          ) {
            rows.push(
              <Table.Row key={`row_rec_header_${headerName}_${rand1}_${rand2}`}>
                <Table.Cell
                  className="text-bold report-sub-title text-center"
                  colSpan={2}
                  width={16}
                >{`${headerName !== undefined ? `${headerName}` : key
                  }`}</Table.Cell>
              </Table.Row>
            );
          }
        }
      } else if (nodeValue !== undefined) {
        const { isSilverReport } = props;
        if ((nodeName.indexOf("Photo ") !== -1) && ignorePhoto) {
          // skip photo info
        } else if (nodeName.toLowerCase().indexOf("token") !== -1) {
          // skip token
        } else if (
          isSilverReport &&
          nodeName.toLowerCase().indexOf("ssn") !== -1
        ) {
          // skip silver report ssn
        } else if (key.toLowerCase() === "picture") {
          // skip picture
        } else if (
          key.toLowerCase() === "ssn" &&
          nodeValue &&
          nodeValue.length === 11
        ) {
          if (!isSilverReport) {
            rows.push(
              <Table.Row key={`row_rec_node_${rand1}_${rand2}`}>
                <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
                  }`}</Table.Cell>
                <Table.Cell width={10}>{getSsn(nodeValue, props)}</Table.Cell>
              </Table.Row>
            );
          }
        } else if (
          (nodeName.indexOf("Photo ") === -1 && !ignoreEmptyNodes) ||
          (ignoreEmptyNodes && nodeValue !== "")
        ) {
          if (nodeName.toLowerCase() === "picture url" && nodeValue !== "") {
            rows.push(
              <Table.Row key={`row_rec_node_${nodeName}_${rand1}_${rand2}`}>
                <Table.Cell width={6} className="text-bold">Picture:</Table.Cell>
                <Table.Cell width={10}><img
                  src={nodeValue}
                  alt="Pic"
                  style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
                /></Table.Cell>
              </Table.Row>
            );
          } else {
            rows.push(
              <Table.Row key={`row_rec_node_${nodeName}_${rand1}_${rand2}`}>
                <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
                  }`}</Table.Cell>
                <Table.Cell width={10} className="word-break-all">{nodeValue}</Table.Cell>
              </Table.Row>
            );
          }
        } else if (
          (nodeName.indexOf("Photo ") === -1 && !ignoreEmptyNodes) ||
          (ignoreEmptyNodes && nodeValue !== "")
        ) {
          rows.push(
            <Table.Row key={`row_rec_node_${nodeName}_${rand1}_${rand2}`}>
              <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
                }`}</Table.Cell>
              <Table.Cell width={10} className="word-break-all">{nodeValue}</Table.Cell>
            </Table.Row>
          );
        }
      } else if (
        key.toLowerCase().indexOf("phone") !== -1 &&
        nodeValue &&
        nodeValue.length > 6
      ) {
        rows.push(
          <Table.Row key={`row_rec_node_${rand1}_${rand2}`}>
            <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
              }`}</Table.Cell>
            <Table.Cell width={10}>{getPhone(nodeValue, props)}</Table.Cell>
          </Table.Row>
        );
      } else if (key.toLowerCase() === "name") {
        const businessName = _.get(collection[key][0], "businessName[0]._", "");
        if (businessName !== "") {
          rows.push(
            <Table.Row key={`row_rec_name_${nodeName}_${rand1}_${rand2}`}>
              <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
                }`}</Table.Cell>
              <Table.Cell width={10}>
                {getBusinessName(businessName, props)}
              </Table.Cell>
            </Table.Row>
          );
        } else {
          rows.push(
            <Table.Row key={`row_rec_name_${nodeName}_${rand1}_${rand2}`}>
              <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
                }`}</Table.Cell>
              <Table.Cell width={10}>
                {getPersonName(
                  _.get(collection[key][0], "first[0]._", "") !== ""
                    ? _.get(collection[key][0], "first[0]._", "")
                    : _.get(collection[key][0], "firstName[0]._", ""),
                  _.get(collection[key][0], "middle[0]._", "") !== ""
                    ? _.get(collection[key][0], "middle[0]._", "")
                    : _.get(collection[key][0], "middleName[0]._", ""),
                  _.get(collection[key][0], "last[0]._", "") !== ""
                    ? _.get(collection[key][0], "last[0]._", "")
                    : _.get(collection[key][0], "lastName[0]._", ""),
                  props
                )}
              </Table.Cell>
            </Table.Row>
          );
        }
      } else if (
        (key.toLowerCase().indexOf("date") !== -1 ||
          key.toLowerCase() === "dob" ||
          key.toLocaleLowerCase() === "taxperiodminimum" ||
          key.toLocaleLowerCase() === "taxperiodmaximum") &&
        nodeValue === undefined
      ) {
        const date = getDate(collection[key], props);
        if (
          !ignoreEmptyNodes ||
          (ignoreEmptyNodes && date !== undefined && date !== "")
        ) {
          rows.push(
            <Table.Row key={`row_rec_date_${nodeName}_${rand1}_${rand2}`}>
              <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
                }`}</Table.Cell>
              <Table.Cell width={10}>{date}</Table.Cell>
            </Table.Row>
          );
        }
      } else if (key.toLowerCase().indexOf("address") !== -1) {
        const addKeys = Object.keys(collection[key][0]);
        let adds = _.filter(
          addKeys,
          (a) => a.toLowerCase().indexOf("address") !== -1
        );
        if (key.toLowerCase().indexOf("addresses") !== -1 && adds.length > 0) {
          if (adds.length > 0) {
            rows.push(
              <Table.Row key={`row_rec_header_addresses_${rand1}_${rand2}`}>
                <Table.Cell
                  className="text-bold report-sub-title text-center"
                  colSpan={2}
                  width={16}
                >{`${nodeName}`}</Table.Cell>
              </Table.Row>
            );
            adds = _.uniq(adds);
            _.forEach(adds, (add, addIndex) => {
              const addresses = _.get(collection[key][0], `${add}`);
              _.forEach(addresses, (address, addsIndex) => {
                rows.push(
                  <Table.Row
                    key={`row_rec_address_${nodeName}_${addIndex}_${addsIndex}_${rand1}_${rand2}`}
                  >
                    <Table.Cell width={6} className="text-bold">
                      {_.get(address, `$.display`)}:
                    </Table.Cell>
                    <Table.Cell width={10}>
                      {<Address {...props} addressNode={address} ignoreLine1 />}
                    </Table.Cell>
                  </Table.Row>
                );
              });
            });
          } else {
            getAllRows(
              collection[key],
              rows,
              props,
              excludeNode,
              level,
              displayOnlyTitle,
              ignoreEmptyNodes,
              ignorePhoto,
              includeId,
              position + 1
            );
          }
        } else {
          rows.push(
            <Table.Row key={`row_rec_other_${nodeName}_${rand1}_${rand2}`}>
              <Table.Cell width={6} className="text-bold">{`${nodeName !== undefined ? `${nodeName}:` : key
                }`}</Table.Cell>
              <Table.Cell width={10}>
                {
                  <Address
                    {...props}
                    addressNode={collection[key][0]}
                    ignoreLine1
                  />
                }
              </Table.Cell>
            </Table.Row>
          );
        }
      } else if (Array.isArray(collection[key])) {
        const innerObjKeys = Object.keys(collection[key][0]);
        if (
          !ignoreEmptyNodes ||
          (nodeValue === undefined && innerObjKeys.length > 1)
        )
          getAllRows(
            collection[key],
            rows,
            props,
            excludeNode,
            level,
            displayOnlyTitle,
            ignoreEmptyNodes,
            ignorePhoto,
            includeId,
            position + 1
          );
      } else {
        getAllRows(
          collection[key],
          rows,
          props,
          excludeNode,
          level,
          displayOnlyTitle,
          ignoreEmptyNodes,
          ignorePhoto,
          includeId,
          position + 1
        );
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/components/reports/ReportElementHelper.js